import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    inputDate = '',
    inputName = '',
    contactPer = '',
    contactTel = '',
    execTotal = 0,
    achieving = '',
    analysis = '',
    suggest = '',
    details = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projMonitor.save, {
        id,
        inputDate,
        inputName,
        contactPer,
        contactTel,
        execTotal,
        achieving,
        analysis,
        suggest,
        details,
    }, options);
    if (error) return { error, status };
    return content || {
        id: '',
    };
};
